module.exports = __webpack_public_path__ + "static/media/mclpl.67d26560.jpg";